import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Router} from '@angular/router';
import { environment } from '../../environments/environment';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class NoticeService {

  apiUrl = environment.apiUrlNotice;
  public showAddNotice: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showAllNotice: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public transactionStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showAddNoticeEndCall: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private  apiKey = environment.apiKey;




  constructor(
    private router: Router,
    private http: HttpClient
  ) {
  }

  consultantNotice(merchantId, consultantId) {
    const header = new HttpHeaders()
      .set('x-api-key', `${this.apiKey}`);
    const params = new  HttpParams({
      fromObject : {
        merchantId,
        consultantId
      }
    });
    return this.http.get(`${this.apiUrl}/consultant-notice-get`, {params: params , headers: header});
  }

  consultantReviews(merchantId, consultantId) {
    const header = new HttpHeaders()
      .set('x-api-key', `${this.apiKey}`);
    const params = new  HttpParams({
      fromObject : {
        merchantId,
        consultantId
      }
    });
    return this.http.get(`${this.apiUrl}/consultant-reviews-get`, {params: params , headers: header});
  }

  customerTransactions(merchantId, customerId, sessionId, consultantId) {
    const header = new HttpHeaders()
      .set('x-api-key', `${this.apiKey}`);
    const params = new  HttpParams({
      fromObject : {
        merchantId,
        customerId,
        sessionId,
        consultantId,

      }
    });
    return this.http.get(`${this.apiUrl}/customer-transactions-get`, {params: params , headers: header});
  }

  customerNoticeSet(formData) {
    const header = new HttpHeaders()
      .set('x-api-key', `${this.apiKey}`);
    return this.http.post(`${this.apiUrl}/customer-notice-set`, formData , {headers: header});
  }

  customerNoticeEnable(formData) {
    const header = new HttpHeaders()
      .set('x-api-key', `${this.apiKey}`);
    return this.http.post(`${this.apiUrl}/customer-notice-enable`, formData , {headers: header});
  }

  customerNoticeCustomerUpdate(formData) {
    const header = new HttpHeaders()
      .set('x-api-key', `${this.apiKey}`);
    return this.http.post(`${this.apiUrl}/customer-notice-customer-update`, formData , {headers: header});
  }



}
